import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import MDInput from "components/MDInput";

function MDTimePicker({ input, onChange, minTime, defaultTime, setDefaultTime, ...rest }) {
  useEffect(() => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 5); // Add 5 minutes to current time
    setDefaultTime(now);
  }, []);

  const handleChange = (selectedDates) => {
    if (onChange) {
      const time = selectedDates[0];
      onChange(time);
    }
  };

  return (
    <Flatpickr
      {...rest}
      value={defaultTime} // Set default value to current time + 5 mins
      options={{
        enableTime: true,
        noCalendar: true,
        dateFormat: "h:i K",
        minTime: minTime,
      }}
      onChange={handleChange}
      render={({ defaultValue }, ref) => (
        <MDInput {...input} defaultValue={defaultValue} inputRef={ref} />
      )}
    />
  );
}

MDTimePicker.defaultProps = {
  input: {},
  onChange: () => {},
  minTime: null,
};

MDTimePicker.propTypes = {
  input: PropTypes.objectOf(PropTypes.any),
  onChange: PropTypes.func,
  minTime: PropTypes.instanceOf(Date),
};

export default MDTimePicker;
